import { localize } from 'vee-validate'
import ko from 'vee-validate/dist/locale/ko.json'

function checkName(name) {
  // name의 마지막 음절의 유니코드(UTF-16)
  const charCode = name.charCodeAt(name.length - 1)

  // 유니코드의 한글 범위 내에서 해당 코드의 받침 확인
  const consonantCode = (charCode - 44032) % 28

  if (consonantCode === 0) {
    // 0이면 받침 없음 -> 를
    return `${name}를`
  }
  // 1이상이면 받침 있음 -> 을
  return `${name}을`
}

localize('ko', Object.assign(ko, {
  names: {
    name: '이름',
    id: '아이디',
    pwd: '비밀번호',
    address: '주소',
    detail_address: '상세주소',
    birthdate: '생년월일',
    mobile_carrier: '통신사',
    phone: '휴대폰번호',
    email: '이메일',
    nickname: '닉네임',
    issue_date: '발급일',
    issued_number: '운전면허번호',
    password_serial_number: '일련번호',
    verify_number: '인증숫자',
    restJuminNumber: '주민등록번호',
    check: '항목'
  },
  messages: {
    required: fieldName => `${checkName(fieldName)} 입력해 주세요.`,
    birthdate: _ => '생년월일을 형식에 맞게 입력해 주세요. 예) 19870131',
    co_kor: _ => '한글로 입력해 주세요.',
    numeric: _ => '숫자만 입력 가능합니다.',
    email: _ => '이메일 형식에 맞게 입력해 주세요.',
    nickname: _ => '2~8자  한글, 영문 소문자, 숫자만 사용해 주세요.',
    verify_number: _ => '인증숫자 4자리를 입력해주세요.',
    issue_date: _ => '발급일을 입력해주세요.',
    issued_number: _ => '운전면허번호를 입력해주세요.',
    password_serial_number: _ => '일련번호를 입력해주세요.',
    restJuminNumber: _ => '주민등록번호를 입력해주세요.',
    name: _ => '10자 이내 한글로 이름을 입력해 주세요.',
    name_extend: _ => '20자 이내 한글, 영문, 공백만 사용해주세요.',
  },
  fields: {
    name: {
      required: _ => '이름을 입력해 주세요.'
    },
    phone: {
      required: _ => '휴대폰번호를 입력해 주세요.',
      phone: _ => '휴대폰번호를 올바르게 입력해 주세요.'
    },
    email: {
      required: _ => '이메일을 입력해 주세요.'
    },
    mobile_carrier: {
      required: _ => '통신사를 선택해 주세요.'
    },
    address: {
      required: _ => '사업장 주소를 선택해 주세요.'
    },
    active_address: {
      required: _ => '주로 활동하는 주소를 입력해 주세요.'
    },
    birthdate: {
      required: _ => '생년월일을 입력해 주세요.'
    },
    birthyyyy: {
      required: _ => '생년월일을 입력해 주세요.'
    },
    birthmm: {
      required: _ => '생년월일을 입력해 주세요.'
    },
    birthdd: {
      required: _ => '생년월일을 입력해 주세요.'
    },
    number_of_table: {
      required: _ => '테이블 개수를 입력해 주세요.'
    },
    store_name: {
      required: _ => '상점명을 입력해 주세요.'
    },
    check: {
      required: _ => '필수 항목입니다.'
    },
    issued_number: {
      required: _ => '운전면허번호를 입력해 주세요.'
    },
    issue_date: {
      required: _ => '발급일을 입력해 주세요.'
    },
    password_serial_number: {
      required: _ => '일련번호를 입력해주세요.'
    },
    restJuminNumber: {
      required: _ => '주민등록번호 뒤 6자리를 입력해주세요.'
    },
    주민등록번호: {
      length: _ => '주민등록번호를 올바르게 입력해주세요.'
    },
    핸드폰번호: {
      min: (name, { length }) => '핸드폰번호를 올바르게 입력해주세요.'
    },
    사업자등록번호: {
      length: _ => '사업자등록번호를 올바르게 입력해주세요.'
    },
    법인등록번호: {
      length: _ => '사업자등록번호를 올바르게 입력해주세요.'
    },
    연간매출액: {
      min_value: _ => '연간매출액을 입력해주세요.'
    },
    상시근로자수: {
      min_value: _ => '상시근로자수를 입력해주세요.'
    },
  }
}))
